/* 
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '../../theme/theme';
import {DLSTheme} from '../../types/types';

export interface CardLabelType {
  color?: string;
  labelText?: string;
  textColor?: string;
  letterSpacing?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  cardLabel : {
    color           : ({textColor}: {textColor: string}) => textColor || dlsColor('white'),
    width           : 'fit-content',
    padding         : '4px',
    overflow        : 'hidden',
    whiteSpace      : 'nowrap',
    borderRadius    : '4px',
    textOverflow    : 'ellipsis',
    // Figma specs 1px for the toast pop-up's badge vs 0.5px for the drawer
    // list card's - callers pass their own value rather than this always
    // being 0.5px ...
    letterSpacing   : ({letterSpacing}: {letterSpacing: string}) => letterSpacing,
    backgroundColor : ({color}: {color: string}) => color,
    ...theme.dls?.typography?.tags
  }
}));

export const CardLabel = ({
  color = dlsColor('grey5'),
  labelText,
  onClick,
  textColor,
  letterSpacing = '0.5px'
}: CardLabelType) => {
  const classes = useStyles({color, textColor, letterSpacing});
  return (
    <div className={classes.cardLabel} onClick={onClick}>
      {labelText}
    </div>
  );
};

export default CardLabel;
